const t = "按 T​​ab 转到弹出框", r = {
  triggerHint: t
};
export {
  r as default,
  t as triggerHint
};
